import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Height } from '@material-ui/icons';
import { Typography, Hidden } from '@material-ui/core';
const { MembershipDetails, SuccessRenewMsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    mainHeading: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    SuccessMsg: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    }
}));

export default function MembershipHeader(props) {

    const classes = useStyles();
    return (
        <Grid container>
            <Grid item xs={12} >

                <Hidden smDown>
                    <Typography className={classes.mainHeading} variant="h1" gutterBottom>
                        {MembershipDetails}
                    </Typography>
                </Hidden>

                <Hidden xsDown mdUp>
                    <Typography className={classes.mainHeading} variant="h2" gutterBottom>
                        {MembershipDetails}
                    </Typography>
                </Hidden>

                <Hidden smUp>
                    <Typography className={classes.mainHeading} variant="h3" gutterBottom>
                        {MembershipDetails}
                    </Typography>
                </Hidden>
            </Grid>
        </Grid>
    );
};
